import React, { useState, useEffect } from "react";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Switch from "react-switch";
import { useFormik } from "formik";
import * as yup from "yup";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import { serverApi, videoUploadSize } from "../../../../../config/Keys";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
//import { ImageUpload } from "../../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOnlineVendor";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import Slider from "react-slick";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import SVG from "react-inlinesvg";
import { FormControl, MenuItem, Select, InputLabel } from "@material-ui/core";
import {
  admin_promo_videos_add,
  admin_promo_videos_edit,
} from "../../../../../store/actions/SuperAdminActions/superAdminPromoVideosAction";
//slider settings
const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const validationSchema = yup.object({
  name: yup
    .string()
    .required("Video name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  // coupon_code: yup
  //   .string()
  //   .required("Coupon code is required")
  //   .min(1, "Minimum 1 Character")
  //   .max(16, "Maximum 15 Character"),
  offerVideo: yup.string().required("Video is required"),
});

const AdminVideo = (props) => {
  //state
  let history = useHistory();
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState();
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const toggleFunction = (e) => {
    setActive({ active: !active.active });
  };
  const [primaryOffer, setPrimaryOffer] = useState(false);
  // const markAsPrimary = (e) => {
  //   setPrimaryOffer({ primaryOffer: !pofferVideorimaryOffer.primaryOffer });
  // };
  // const uploadImage = (e) => {
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const thumbnail = true;
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);

  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("photos", mergedData);
    if (thumbnail) {
      let thumbData = formik.values.photo_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formik.setFieldValue("photo_thumbnails", thumbData);
    }
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    if (formik.values.photos.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name = "admin";

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik.values.image_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
    formik.setFieldValue("photo_thumbnails", thumbImage);
  };
  const [progress, setProgress] = useState(0);

  const uploadVideo = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        // setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            onUploadProgress: (progressEvent) => {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            },
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            // setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            setVideo(res.data);
            //formik.setFieldValue("photos", res.data[0]);
            formik.setFieldValue(`offerVideo`, res.data);
          })
          .catch((err) => {
            setLoading(false);
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    setVideo(null);
    formik.setFieldValue(`offerVideo`, "");
  };

  const onSuccessAddOffer = () => {
    setLoading(false);
    history.push("/superadmin/promotional-videos");
  };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(" "));
  };

  useEffect(() => {
    if (props?.editData?.video) {
      setVideo(props?.editData?.video);
    }
  }, [props?.editData?.video]);

  useEffect(() => {
    if (props?.editData?.title) {
      titleCase(props?.editData?.title);
    }
  }, [props?.editData?.title]);

  useEffect(() => {
    if (props?.editData?.video_tag) {
      setKeywords(props?.editData?.video_tag);
    }
  }, [props?.editData?.video_tag]);

  const formik = useFormik({
    initialValues: {
      name: props?.editData?.title || "",
      description: props?.editData?.description || "",
      primary: props?.editData?.make_video_primary || false,
      start_date:
        moment(new Date(props?.editData?.start_date)).format("YYYY-MM-DD") ||
        "",
      start_time:
        moment(new Date(props?.editData?.start_date)).format("hh:mm") || "",
      end_date:
        moment(new Date(props?.editData?.end_date)).format("YYYY-MM-DD") || "",
      end_time:
        moment(new Date(props?.editData?.end_date)).format("hh:mm") || "",
      coupon_code: "",
      photos: [],
      photo_thumbnails: [],
      offerVideo: props?.editData?.video || "",
      terms_and_condition: "",
      classification: 1,
      merchant: props?.editData?.merchant_id || "",
      event: props?.editData?.event_id || "",
      priority: props?.editData?.priority || "",
      status: props?.editData?.status ? "ACTIVE" : "PENDING",
    },
    validationSchema,

    onSubmit: (values) => {
      var formData = {
        title: values.name,
        description: values.description,
        make_video_primary: values.primary,
        start_date: values.start_date + " " + values.start_time,
        end_date: values.end_date + " " + values.end_time,
        video_classification: values.classification,
        video_img: "",
        video: values.offerVideo,
        video_tag: keywords,
        priority: values.priority,
        status: active.active ? "ACTIVE" : "PENDING",
        merchant_id: values.merchant,
        merchant_name: values.merchant,
        event_id: values.event,
      };

      // const startDate = {
      //   start_date:
      //     // moment(
      //     values.start_date + " " + values.start_time,
      //   // ).toISOString()
      // };
      // const end_Date = {
      //   end_date:
      //     // moment(
      //     values.end_date + " " + values.end_time,
      //   // ).toISOString()
      // };

      // // var location = {
      // //   latitude: "26.23568784466822",
      // //   longitude: "78.15339087385253",
      // // };

      // formData.title = values.name;
      // formData.description = values.description;
      // formData.start_date = startDate.start_date;
      // formData.end_date = end_Date.end_date;
      // formData.video_img = "";
      // formData.video = values.offerVideo;
      // formData.priority = values.priority;
      // formData.status = active.active ? "ACTIVE" : "PENDING";
      // formData.make_video_primary = values.primary;
      // formData.video_classification = values.classification;
      // formData.merchant = values.merchant;
      // formData.event = values.event;
      // formData.video_tag = keywords;

      // formData.mark_as_primary = primaryOffer.primaryOffer;
      // formData.send_to_carousel = "false";

      const onErrorAddOffer = () => {
        setLoading(false);
      };
      const token = props.auth.user.accessToken;
      setLoading(true);
      if (props?.edit) {
        props.admin_promo_videos_edit(
          props?.editData?._id,
          token,
          formData,
          onSuccessAddOffer,
          onErrorAddOffer
        );
      } else {
        props.admin_promo_videos_add(
          token,
          formData,
          onSuccessAddOffer,
          onErrorAddOffer
        );
      }
    },
  });
  console.log(props?.editData?.title, formik.values.name);
  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const setPriority = (e) => {
    formik.setFieldValue("priority", e.target.value);
  };

  // useEffect(() => {
  //   formik.setFieldValue("name", "");
  // }, []);
  const setClassification = (e) => {
    formik.setFieldValue("classification", e);
  };

  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.offerVideo) {
      let endTimeElement = document.getElementById("offer_video");
      endTimeElement.focus();
      // } else if (formik.errors && formik.errors.coupon_code) {
      //   let couponCodeElement = document.getElementById("coupon_code");
      //   couponCodeElement.focus();
    }
  }, [count]);
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  const [errors, setErrors] = useState({});
  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  const markAsPrimary = (e) => {
    formik.setFieldValue("primary", !formik.values.primary);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);
  return (
    <>
      <React.Fragment>
        {!loading ? (
          <>
            <Form>
              <Row className="pt-4">
                <Col lg={8}>
                  <Form.Group>
                    <TextField
                      // ref={nameee}
                      id="name"
                      label="Video Name"
                      type="text"
                      value={formik.values.name}
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.name && formik.touched.name
                          ? "enError"
                          : ""
                      }`}
                      name="name"
                      //onChange={formik.handleChange}
                      onChange={(e) => titleCase(e.target.value, "name")}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.errors.name && formik.touched.name}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      // ref={description}
                      id="description"
                      label="Description"
                      type="text"
                      multiline
                      rows="5"
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.description && formik.touched.description
                          ? "enError"
                          : ""
                      }`}
                      name="description"
                      //onChange={formik.handleChange}
                      onChange={(e) =>
                        Capitalize(e.target.value, "description")
                      }
                      value={formik.values.description}
                      onBlur={formik.handleBlur}
                      //onInvalid={formik.errors.email && formik.touched.email}
                      isInvalid={
                        formik.errors.description && formik.touched.description
                      }
                    />
                    {formik.errors.description && formik.touched.description ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </Form.Group>
                  <Row className="pb-4">
                    <Col lg={6}>
                      <div className="f12-400">
                        (Fill out the details , videos are used offline)
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="d-flex align-items-start">
                        <Switch
                          onChange={markAsPrimary}
                          checked={formik.values.primary}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                        <div className="pl-2">
                          <div className="f12-500 mb-2">
                            Make this Video Primary
                          </div>
                          <div className="f10-400">
                            (Note you can make only one Video primary, by making
                            this video primary it will remove primary from other
                            active videos)
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}>
                  <hr />
                  <div className="font_20_b py-4">Video Details</div>
                  <Row className="pb-4 align-items-center">
                    <Col md={3} xl={2}>
                      <TextField
                        id="start_date"
                        label="Start Date"
                        variant="outlined"
                        InputProps={{
                          inputProps: { min: minDate },
                        }}
                        type="date"
                        disablePast
                        minDate={new Date()}
                        //minDate={new Date())}
                        className={`w-100 ${
                          formik.errors.start_date && formik.touched.start_date
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="start_date"
                        onChange={(e) => handleStartDateChange(e)}
                        value={formik.values.start_date}
                        onBlur={formik.handleBlur}
                        //onInvalid={formik.errors.email && formik.touched.email}
                        isInvalid={
                          formik.errors.start_date && formik.touched.start_date
                        }
                      />
                      {formik.errors.start_date && formik.touched.start_date ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.start_date}
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} xl={2}>
                      <TextField
                        id="start_time"
                        label="Start Time"
                        variant="outlined"
                        type="time"
                        className={`w-100 ${
                          formik.errors.start_time && formik.touched.start_time
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="start_time"
                        onChange={formik.handleChange}
                        value={formik.values.start_time}
                        onBlur={formik.handleBlur}
                        //onInvalid={formik.errors.email && formik.touched.email}
                        isInvalid={
                          formik.errors.start_time && formik.touched.start_time
                        }
                      />
                      {formik.errors.start_time && formik.touched.start_time ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.start_time}
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} xl={2}>
                      <TextField
                        id="end_date"
                        label="End Date"
                        variant="outlined"
                        InputProps={{
                          inputProps: { min: minEndDate },
                        }}
                        type="date"
                        className={`w-100 ${
                          formik.errors.end_date && formik.touched.end_date
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="end_date"
                        onChange={formik.handleChange}
                        value={formik.values.end_date}
                        onBlur={formik.handleBlur}
                        //onInvalid={formik.errors.email && formik.touched.email}
                        isInvalid={
                          formik.errors.end_date && formik.touched.end_date
                        }
                      />
                      {formik.errors.end_date && formik.touched.end_date ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.end_date}
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} xl={2}>
                      <TextField
                        id="end_time"
                        label="End Time"
                        variant="outlined"
                        type="time"
                        className={`w-100 ${
                          formik.errors.end_time && formik.touched.end_time
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="end_time"
                        onChange={formik.handleChange}
                        value={formik.values.end_time}
                        onBlur={formik.handleBlur}
                        //onInvalid={formik.errors.email && formik.touched.email}
                        isInvalid={
                          formik.errors.end_time && formik.touched.end_time
                        }
                      />
                      {formik.errors.end_time && formik.touched.end_time ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.end_time}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="pb-4 align-items-center">
                    {/* <Col md={4} lg={4}>
                      <Form.Group>
                        <TextField
                          id="coupon_code"
                          label="Coupon Code"
                          type="text"
                          variant="outlined"
                          className={`w-100 ${
                            formik.errors.coupon_code &&
                            formik.touched.coupon_code
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="coupon_code"
                          onChange={formik.handleChange}
                          value={formik.values.coupon_code}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.errors.coupon_code &&
                            formik.touched.coupon_code
                          }
                        />
                        {formik.errors.coupon_code &&
                        formik.touched.coupon_code ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.coupon_code}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col> */}
                    {/* <Col md={4} lg={4}> */}
                    {/* <Form.Group>
                  <TextField
                    label="Maximum Usage Limit"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group> */}
                    {/* </Col> */}
                    <Col md={4} lg={4}>
                      <div className="form-group d-flex align-items-center">
                        <div className="f18-500 mr-2">Status</div>
                        <div className="f12-400 mr-2">
                          {active.active ? "Active" : "Inactive"}
                        </div>
                        <Switch
                          onChange={toggleFunction}
                          checked={active.active}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                        />
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  {/* <Form.Group className="py-4">
                    {/* <ImageUpload /> */}
                  {/* <div className="event-offer-image">
                    <SimpleReactLightbox>
                      <MultipleImageUploadComponent
                        title="Upload Images"
                        smallTitle="(You can upload maximum 6 pic per event 700 x 420 pixels)"
                        onChange={bankUploadMultipleFiles}
                        //stateValue={bank_informaion}
                        stateValue={formik.values.photos}
                        newUploaded={
                          restaurant_pictures_new ? restaurant_pictures_new : []
                        }
                        combined={combined}
                        onCompleteUploadMultipleCrop={
                          onCompleteUploadMultipleCrop
                        }
                        removeImage={bankDocMultipleRemove}
                        accept="image/gif,image/jpeg,image/jpg,image/png"
                        // loader={state.bankImageLoader}
                        thumbnail={thumbnail}
                      />
                    </SimpleReactLightbox>
                  </div>
                  {formik.errors.photos && formik.touched.photos ? (
                    <div className="mb-3 pho_14_regular text-danger">
                      {formik.errors.photos}
                    </div>
                  ) : (
                    <div className="mb-3"> </div>
                  )} */}
                  {/* <Form.Label className="f14-500 mb-3">Add Photos</Form.Label>
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => uploadImage(e)}
                  />
                </div>
                {file && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => removeImage()}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <Image
                      src={file}
                      alt="icon"
                      title="icon"
                      className=""
                      fluid
                    />
                  </div>
                )}
              </div>
              <div className="pt-2 f12-400">
                (You can upload only 1 pic per offer 700 x 420 pixels)
              </div> */}
                  {/* </Form.Group> */}{" "}
                  <Form.Group className="pb-4">
                    <Form.Label className="f14-500 mb-3">
                      Video Classification
                    </Form.Label>
                    <div
                      class="row col-12 d-flex column-2 align-items-center"
                      style={{
                        // border: "2px solid rgb(230, 230, 230)",
                        // overflowY: "scroll",
                        // maxHeight: "232px",
                        paddingTop: "2vh",
                        borderRadius: "6px",
                      }}
                    >
                      <div
                        class="position-relative col-md-2 col-6 mr-0"
                        onClick={() => setClassification(1)}
                      >
                        <div
                          class={`w-100 mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                            formik.values.classification === 1 &&
                            `onboarding_mapbutton_reusable_active_two`
                          }`}
                        >
                          <div class="d-flex align-items-center">
                            <span style={{ fontSize: "2vh" }}>
                              {" "}
                              Merchant Promotional <br />
                              Video
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="position-relative col-md-2 col-6 mr-0"
                        onClick={() => setClassification(0)}
                      >
                        <div
                          class={`w-100 mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                            formik.values.classification === 0 &&
                            `onboarding_mapbutton_reusable_active_two`
                          }`}
                        >
                          <div class="d-flex align-items-center">
                            <span style={{ fontSize: "2vh" }}>
                              {" "}
                              Admin Promotional <br />
                              Video
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {formik.values.classification === 1 && (
                      <>
                        {" "}
                        <div className="mt-3 row">
                          <div className="col-6">
                            <Form.Group>
                              <TextField
                                // ref={nameee}
                                id="merchant"
                                label="Add Merchant Name or ID"
                                type="text"
                                variant="outlined"
                                className={`w-100 ${
                                  formik.errors.merchant &&
                                  formik.touched.merchant
                                    ? "enError"
                                    : ""
                                }`}
                                name="merchant"
                                //onChange={formik.handleChange}
                                onChange={(e) =>
                                  titleCase(e.target.value, "merchant")
                                }
                                value={formik.values.merchant}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.merchant &&
                                  formik.touched.merchant
                                }
                              />
                              {formik.errors.merchant &&
                              formik.touched.merchant ? (
                                <div className="pho_14_regular text-danger">
                                  {formik.errors.merchant}
                                </div>
                              ) : null}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="mt-2 row">
                          <div className="col-6">
                            <Form.Group>
                              <TextField
                                id="event"
                                label="Add event Name or ID"
                                type="text"
                                variant="outlined"
                                className={`w-100 ${
                                  formik.errors.event && formik.touched.event
                                    ? "enError"
                                    : ""
                                }`}
                                name="event"
                                //onChange={formik.handleChange}
                                onChange={(e) =>
                                  titleCase(e.target.value, "event")
                                }
                                value={formik.values.event}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.event && formik.touched.event
                                }
                              />
                              {formik.errors.event && formik.touched.event ? (
                                <div className="pho_14_regular text-danger">
                                  {formik.errors.event}
                                </div>
                              ) : null}
                            </Form.Group>
                          </div>
                        </div>
                      </>
                    )}
                  </Form.Group>
                  {!progress && progress === 0 ? null : (
                    <AlertDialogProgress
                      progress={progress}
                      title="Video Uploading..."
                    />
                  )}
                  <Form.Group className="pb-4">
                    <Form.Label className="f14-500 mb-3">
                      {props?.edit ? "Add" : "Edit"} Video
                    </Form.Label>

                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".mp4"
                          onChange={uploadVideo}
                        />
                      </div>
                      <Slider
                        {...settings}
                        className={`sliderUploadImges video-upload`}
                        // style={videoUpload && { width: "226px" }}
                      >
                        {Video && (
                          <div className="enIconUploaded">
                            <button
                              type="button"
                              className="enCloseButton"
                              onClick={() => removeVideo()}
                            >
                              <Image
                                src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                                alt="uploadImg"
                                title="uploadImg"
                                fluid
                              />
                            </button>
                            <video
                              width="100%"
                              height="100%"
                              controls
                              src={Video}
                              type="video/mp4"
                            />
                          </div>
                        )}
                      </Slider>
                    </div>
                    <div className="pt-2 f12-400">
                      (You can upload only 1 video per video)
                    </div>
                  </Form.Group>
                  <div className="font_20_b py-4">Video Tags</div>
                  <Row>
                    <Col md={4} className="mt-3">
                      <div className=" onboarding-restaurant-details-margin">
                        <div className="row align-items-center">
                          <div className="col-8">
                            <NewInputText
                              extraClass="mb-1"
                              name="keywordsText"
                              onChange={onKeywordsChangeHandler}
                              value={keywordsText}
                              labelText="Keywords"
                            />
                            <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                              {errors.keywordsText}
                            </div>
                          </div>
                          <div className="col-4">
                            <AddButtonIconComponent
                              buttonText="Add"
                              onClick={addKeywordsAction}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4} className="mt-3">
                      {keywords && keywords.length > 0 ? (
                        <div className="col-12 p-0 onboarding-restaurant-details-margin">
                          <div className="enChipBox border-0">
                            <Scrollbars style={{ width: "100%", height: 135 }}>
                              {keywords &&
                                keywords.map((data, index) => {
                                  return (
                                    <div className="mb-3 mr-3" key={index}>
                                      <div className="keywords_button">
                                        <p>{data}</p>
                                        <span
                                          className="ml-2"
                                          onClick={removeKeywordsAction(index)}
                                        >
                                          <SVG
                                            src={require("../../../../../assets/images/UserManagement/close.svg")}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                            </Scrollbars>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Set Video Priority
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={formik.values.priority}
                          label="Priority"
                          onChange={setPriority}
                          variant="outlined"
                          fullWidth
                        >
                          <MenuItem value={1}>Priority 1</MenuItem>
                          <MenuItem value={2}>Priority 2</MenuItem>
                          <MenuItem value={3}>Priority 3</MenuItem>
                          <MenuItem value={4}>Priority 4</MenuItem>
                          <MenuItem value={5}>Priority 5</MenuItem>
                          <MenuItem value={6}>Priority 6</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                  </Row>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={() => onSuccessAddOffer()}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      //type="submit"
                      onClick={() => onClickSave()}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>{" "}
          </>
        ) : (
          <AmealioLoader />
        )}
      </React.Fragment>
    </>
  );
};

AdminVideo.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_promo_videos_add: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  admin_promo_videos_add,
  admin_promo_videos_edit,
})(AdminVideo);
